import { DOCUMENT } from "@angular/common";
import { Component, Inject, Input, OnDestroy, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { BehaviorSubject, Subject, Subscription, takeUntil } from "rxjs";
import { environment } from "../../../environments/environment";
import { GlobalSearchService } from "../global-search.service";
import { SearchActionsService } from "../search-actions.service";
import { SearchHistoryService } from "../search-history.service";

@Component({
    selector: "app-search-products-view",
    templateUrl: "./search-products-view.component.html",
    styleUrls: ["./search-products-view.component.scss"],
})
export class SearchProductsViewComponent implements OnInit, OnDestroy {
    readonly itemSize = 176;
    products$ = new BehaviorSubject([]);
    isLoading$ = new BehaviorSubject(false);
    destroy$ = new Subject<void>();
    searchSubscription: Subscription;
    lastSearchKey = '';
    params = { searchText: "", orderBy: "products.price ASC" };
    environment = environment;
    orderControl = new FormControl("From A to Z");
    orderOptions = [
        {
            name: "From A to Z",
            value: "products.name ASC",
        },
        {
            name: "From Z to A",
            value: "products.name DESC",
        },
        {
            name: "Ascending price",
            value: "price ASC",
        },
        {
            name: "Descending price",
            value: "price DESC",
        },
    ];

    constructor(
        private searchService: GlobalSearchService,
        private searchActionsService: SearchActionsService,
        private searchHistoryService: SearchHistoryService
    ) {}

    ngOnInit(): void {
        const currentKeyword = this.searchService.currentSearchTerm.trim();
        if (currentKeyword) {
            this.params = { ...this.params, searchText: currentKeyword };
            this.search();
        }

        this.searchService.searchStored$
            .pipe(takeUntil(this.destroy$))
            .subscribe((keyword: string) => {
                this.params = { ...this.params, searchText: keyword };
                this.search();
            });
        this.orderControl.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((order: string) => {
                this.params = { ...this.params, orderBy: order };
                this.search();
            });
    }
    search(): any {
        if (!this.params.searchText?.trim()) {
            this.products$.next([]);
            this.isLoading$.next(false);
            this.lastSearchKey = '';
            return;
        }

        const searchKey = `${this.params.searchText.trim()}|${this.params.orderBy || ''}`;
        if (this.searchSubscription && !this.searchSubscription.closed && this.lastSearchKey === searchKey) {
            return;
        }
        this.lastSearchKey = searchKey;

        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
            this.searchSubscription = null;
        }

        this.products$.next([]);
        this.isLoading$.next(true);
        this.searchSubscription = this.searchService.searchProducts(this.params).subscribe({
            next: ({ data }) => {
                this.products$.next(data.data || []);
                this.isLoading$.next(false);
            },
            error: () => {
                this.products$.next([]);
                this.isLoading$.next(false);
            },
        });
    }
    redirectTo(product: any) {
        this.searchHistoryService.addHistoryItem({
            type: "product",
            name: product.name,
            data: product,
        });
        this.searchActionsService.editProduct(product);
    }
    redirectToPublicView(product: any) {
        this.searchHistoryService.addHistoryItem({
            type: "product",
            name: product.name,
            data: product,
        });
        this.searchActionsService.redirectToProductPublicView(product);
    }
    triggerShowMore(event: { target: HTMLElement }) {
        if (event.target.parentElement.classList.contains("show-less")) {
            event.target.parentElement.classList.remove("show-less");
        } else {
            event.target.parentElement.classList.add("show-less");
        }
    }
    getProductImage(order) {
        if (order?.checkoutImages?.length) {
            return order.checkoutImages[0].url;
        }
    }
    ngOnDestroy(): void {
        this.destroy$.next();
        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
            this.searchSubscription = null;
        }
    }
}
